import { Button } from "@/components/ui/button";
import { GradientButton } from "@/components/ui/gradient-button";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export const Navigation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setIsAuthenticated(!!session);
      console.log("Auth state changed:", event, session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleSignupClick = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (session) {
      toast.info("You're already signed in!", {
        description: "Please log out first if you want to create a new account.",
      });
      navigate("/opportunities");
      return;
    }
    
    navigate("/signup");
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
      <div className="flex items-center">
        <img 
          src="/app_images/Sonho_Favicon_V2.png" 
          alt="Sonho Logo" 
          className="h-8 w-auto"
        />
      </div>
      <div className="flex items-center space-x-4">
        <LanguageToggle />
        <div className="flex items-center space-x-3">
          <Button 
            variant="outline" 
            onClick={handleLoginClick}
            className="h-9 px-4 sm:h-10"
          >
            {t('auth.login')}
          </Button>
          <GradientButton 
            onClick={handleSignupClick}
            className="h-9 px-4 sm:h-10"
          >
            {t('auth.signup')}
          </GradientButton>
        </div>
      </div>
    </nav>
  );
};